import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-[#DCE3EC] mt-20 py-10 bg-[#F5F8FB] text-[#5C6670] text-sm">
      <div className="reading-column px-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
        <div>
          Kanmanfryse.dk er en uafhængig guide om frysning af mad.
        </div>
        <div>
          <Link 
            to="/om" 
            className="text-[#2A4DB0] hover:underline"
          >
            Om siden
          </Link>
        </div>
      </div>
    </footer>
  );
}
